var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center"},[_c('v-dialog',{attrs:{"value":_vm.value,"width":"90%"},on:{"input":function($event){return _vm.$emit('input')}}},[_c('v-card',[_c('v-card-text',{staticClass:"pa-0"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }